export const EXTERNAL_LOAN_PROTECTED_SAVINGS_PERCENTAGE = 0.2;

export const EXTERNAL_LOAN_STANDARD_INTEREST_PLAN = 'STANDARD';
export const EXTERNAL_LOAN_STANDARD_INTEREST_PLAN_LABEL = 'Standard';
export const EXTERNAL_LOAN_DEFAULT_DAILY_INTEREST_RATE_PERCENT = 12;
export const EXTERNAL_LOAN_INTEGRATION_TEST_DAILY_INTEREST_RATE_PERCENT = 15;
export const EXTERNAL_LOAN_REPAYMENT_FREQUENCY_DAILY = 'DAILY';
export const EXTERNAL_LOAN_REPAYMENT_FREQUENCY_DAILY_LABEL = 'Daily';

export const EXTERNAL_LOAN_INTEREST_PLANS = [
  { value: EXTERNAL_LOAN_STANDARD_INTEREST_PLAN, label: EXTERNAL_LOAN_STANDARD_INTEREST_PLAN_LABEL },
];

export const EXTERNAL_LOAN_REPAYMENT_FREQUENCIES = [
  { value: EXTERNAL_LOAN_REPAYMENT_FREQUENCY_DAILY, label: EXTERNAL_LOAN_REPAYMENT_FREQUENCY_DAILY_LABEL },
];

export const EXTERNAL_LOAN_STATUS_LABELS = {
  pending: 'Pending',
  'under-review': 'Under Review',
  approved: 'Approved',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
};

export const EXTERNAL_LOAN_STATUS_COLORS = {
  pending: 'warning',
  'under-review': 'info',
  approved: 'success',
  rejected: 'error',
  cancelled: 'default',
};
